import classNames from 'classnames'
import { FocusEvent, RefObject, useMemo } from 'react'

import { IInputProps, InputDisabledWrapper } from 'core-components/library/inputs'

import { DropdownArrowWithContext } from '../components/DropdownArrowWithContext'
import styles from '../Dropdown.module.scss'

interface IUseInputProps {
  classes?: IInputProps['classes']
  dir?: IInputProps['dir']
  startContent?: IInputProps['startContent']
  endContent?: IInputProps['endContent']
  onKeyPress: IInputProps['onKeyPress']
  disabled?: boolean
  disabledInput?: boolean
  label?: IInputProps['label']
  placeholder?: IInputProps['placeholder']
  placeholderTemplate?: IInputProps['placeholderTemplate']
  autoFocus?: boolean
  __testId?: IInputProps['__testId']

  isPopupOpened: boolean
  inputted: string
  setInputtedBeforeFocus: (newValue: string) => void
  onChange: (text: string) => void
  onBlur: (event: FocusEvent<HTMLDivElement>) => void
  inputRef: RefObject<HTMLInputElement | null>
}

export const useInputProps = (props: IUseInputProps) => {
  return useMemo<IInputProps>(() => {
    return {
      dir: props.dir,
      autocompleteOff: true,
      classes: {
        ...props.classes,
        root: classNames(
          !props.disabled && props.disabledInput ? styles.disabledInput : '',
          props.classes?.root
        ),
      },
      ref: props.inputRef,
      disabled: props.disabled || props.disabledInput,
      value: props.inputted,
      label: props.label,
      placeholder: props.placeholder,
      placeholderTemplate: props.placeholderTemplate,
      autoFocus: props.autoFocus,
      onKeyPress: props.onKeyPress,
      startContent: props.startContent,
      endContent: props.endContent ? (
        props.endContent
      ) : (
        <InputDisabledWrapper disabled={props.disabled}>
          <DropdownArrowWithContext state={props.isPopupOpened ? 'up' : 'down'} />
        </InputDisabledWrapper>
      ),
      onChange: props.onChange,
      onFocus: () => {
        props.setInputtedBeforeFocus(props.inputted)
      },
      onBlur: props.onBlur,
      __testId: props.__testId,
    }
  }, [props])
}
